import { useRoutes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import {
  BankingApi,
  Bbps,
  Ekyc,
  HomePage,
  PosSolution,
  PrepaidCard,
  SoundBox,
  Upi,
} from "../pages";
import AboutUs from "../pages/AboutUs";
import ContactPage from "../pages/ContactPage";
import Downloads from "../pages/Download";
import Media from "../pages/Media";
import NotFound from "../pages/NotFound";
import { Enach } from "../pages/products/Enach";
import RootRedirect from "../pages/RootRedirect";

const pages = [
  {
    index: true,
    element: <HomePage />,
  },
  {
    path: "soundbox",
    element: <SoundBox />,
  },
  {
    path: "about-us",
    element: <AboutUs />,
  },
  {
    path: "banking",
    element: <BankingApi />,
  },
  {
    path: "bbps",
    element: <Bbps />,
  },
  {
    path: "upi-qr",
    element: <Upi />,
  },
  {
    path: "enach",
    element: <Enach />,
  },
  {
    path: "ekyc",
    element: <Ekyc />,
  },
  {
    path: "pos-solution",
    element: <PosSolution />,
  },
  {
    path: "prepaid-card",
    element: <PrepaidCard />,
  },
  {
    path: "media",
    element: <Media />,
  },
  {
    path: "contact",
    element: <ContactPage />,
  },
  {
    path: "downloads",
    element: <Downloads />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

const Routers = () => {
  const routing = useRoutes([
    {
      path: "/",
      element: <RootRedirect />,
    },
    {
      path: "/vi",
      element: <MainLayout />,
      children: pages,
    },
    {
      path: "/en",
      element: <MainLayout />,
      children: pages,
    },
  ]);
  return routing;
};

export default Routers;
